export const nutritionColumns = [
  'calories',
  'Total Lipids',
  'Total Fat',
  'Total Saturated Fat',
  'Total Unsaturated Fat',
  'Monounsaturated Fat',
  'Polyunsaturated Fat',
  'Total Trans Fat',
  'Monoenoic Trans Fat',
  'Dienoic Trans Fat',
  'Polyenoic Trans Fat',
  'Total Saturated Fats',
  'Monounsaturated Fats',
  'Polyunsaturated Fats',
  'Trans-Monoenoic Fats',
  'Trans-Dienoic Fats',
  'Trans-Polyenoic Fats',
  'Trans Fats',
  'Total lipid (fat)',
  'Total fat (NLEA)',
  'Lipids',
  'Protein',
  'Energy1',
  'Energy2',
  'Energy (Atwater General Factors)',
  'Energy (Atwater Specific Factors)',
  'Carbohydrates',
  'Carbohydrate; by difference',
  'Carbohydrate; by summation',
  'Total Sugars',
  'Sugars; Total',
  'Sugars; added',
  'Total dietary fiber (AOAC 2011.25)',
  'Fiber; total dietary',
  'Fiber; soluble',
  'Fiber; insoluble',
  'High Molecular Weight Dietary Fiber (HMWDF)',
  'Low Molecular Weight Dietary Fiber (LMWDF)',
  'Sucrose',
  'Glucose',
  'Fructose',
  'Lactose',
  'Maltose',
  'Galactose',
  'Starch',

  'Cholesterol',
  'Water',
  'Nitrogen',
  'Ash',
  'Minerals',
  'Calcium; Ca',
  'Iron; Fe',
  'Magnesium; Mg',
  'Phosphorus; P',
  'Potassium; K',
  'Sodium; Na',
  'Zinc; Zn',
  'Copper; Cu',
  'Fluoride; F',
  'Iodine; I',
  'Manganese; Mn',
  'Molybdenum; Mo',
  'Selenium; Se',

  'Vitamin A; IU',
  'Vitamin A; RAE',
  'Vitamin B-6',
  'Vitamin B-12',
  'Vitamin B-12; added',
  'Vitamin C; total ascorbic acid',
  'Vitamin D (D2 + D3); International Units',
  'Vitamin D (D2 + D3)',
  'Vitamin D2 (ergocalciferol)',
  'Vitamin D3 (cholecalciferol)',
  'Vitamin E',
  'Vitamin E (alpha-tocopherol)',
  'Vitamin E; added',
  'Vitamin K (Dihydrophylloquinone)',
  'Vitamin K (Menaquinone-4)',
  'Vitamin K (phylloquinone)',
  'Vitamins and Other Components',

  'Organic acids',
  'Aspartic acid',
  'Glutamic acid',
  'Citric acid',
  'Malic acid',
  'Oxalic acid',
  'Quinic acid',
  'Pyruvic acid',
  'Folic acid',
  'Amino acids',
  'Pantothenic acid',

  'Alcohol; ethyl',
  'Caffeine',
  'Theobromine',
  'Retinol',
  'Carotene; beta',
  'Carotene; alpha',
  'Carotene; gamma',
  'cis-beta-Carotene',
  'trans-beta-Carotene',
  'Thiamin',
  'Riboflavin',
  'Niacin',
  'Folate; total',
  'Folate; food',
  'Folate; DFE',
  'Choline; total',
  'Choline; free',
  'Choline; from phosphocholine',
  'Choline; from phosphotidyl choline',
  'Choline; from glycerophosphocholine',
  'Choline; from sphingomyelin',
  'Cryptoxanthin; alpha',
  'Cryptoxanthin; beta',
  'Lutein',
  'Lutein + zeaxanthin',
  'cis-Lutein/Zeaxanthin',
  'Zeaxanthin',
  'Lycopene',
  'cis-Lycopene',
  'trans-Lycopene',
  'Phytoene',
  'Phytofluene',
  'Tocopherol; beta',
  'Tocopherol; gamma',
  'Tocopherol; delta',
  'Tocotrienol; alpha',
  'Tocotrienol; beta',
  'Tocotrienol; gamma',
  'Tocotrienol; delta',
  '25-hydroxycholecalciferol',
  'Biotin',
  'Betaine',
  'Tryptophan',
  'Threonine',
  'Isoleucine',
  'Leucine',
  'Lysine',
  'Methionine',
  'Cystine',
  'Phenylalanine',
  'Tyrosine',
  'Valine',
  'Arginine',
  'Histidine',
  'Alanine',
  'Glycine',
  'Proline',
  'Serine',
  'Hydroxyproline',
  'Cysteine',
  'Phytosterols',
  'Daidzein',
  'Genistein',
  'Isoflavones',
  'Proximates',
  'Daidzin',
  'Genistin',
  'Glycitin',

  'TFA 18:2 t not further defined',
  'TFA 18:3 t',
  'MUFA 14:1',
  'PUFA 18:3i',
  'SFA 11:0',
  'SFA 24:0',
  'MUFA 22:1 c',
  'MUFA 22:1 n-9',
  'MUFA 24:1 c',
  'PUFA 18:2 n-6 c;c',
  'PUFA 18:2 CLAs',
  'PUFA 18:3 n-3 c;c;c (ALA)',
  'PUFA 20:3 n-3',
  'PUFA 20:3 n-6',
  'PUFA 20:3 n-9',
  'PUFA 20:5c',
  'PUFA 22:2',
  'PUFA 22:5 c',
  'PUFA 22:4',
  'PUFA 22:6 c',
  'TFA 16:1 t',
  'TFA 18:1 t',
  'TFA 22:1 t',
  'SFA 5:0',
  'SFA 7:0',
  'SFA 4:0',
  'SFA 6:0',
  'SFA 8:0',
  'SFA 10:0',
  'SFA 12:0',
  'SFA 14:0',
  'SFA 16:0',
  'SFA 18:0',
  'MUFA 16:1',
  'MUFA 18:1',
  'MUFA 20:1',
  'MUFA 22:1',
  'PUFA 18:2',
  'PUFA 18:3',
  'PUFA 18:4',
  'PUFA 20:4',
  'PUFA 20:5 n-3 (EPA)',
  'PUFA 22:5 n-3 (DPA)',
  'PUFA 22:6 n-3 (DHA)',
  'SFA 9:0',
  'SFA 21:0',
  'SFA 23:0',
  'MUFA 12:1',
  'MUFA 22:1 n-11',
  'PUFA 22:3',
  'TFA 14:1 t',
  'TFA 20:1 t',
  'PUFA 21:5',
  'SFA 13:0',
  'SFA 15:0',
  'SFA 17:0',
  'SFA 20:0',
  'SFA 22:0',
  'MUFA 14:1 c',
  'MUFA 15:1',
  'MUFA 16:1 c',
  'MUFA 17:1',
  'MUFA 17:1 c',
  'MUFA 18:1 c',
  'MUFA 20:1 c',
  'PUFA 18:2 c',
  'PUFA 18:3 c',
  'PUFA 18:3 n-6 c;c;c',
  'PUFA 20:2 c',
  'PUFA 20:2 n-6 c;c',
  'PUFA 20:3',
  'PUFA 20:3 c',
  'PUFA 20:4c',
];
